import React, { createContext, useMemo } from 'react'
import useLocalStorage from 'main/hooks/useLocalStorage'

const initialState = {
  dataHash: null,
  setDataHash: ()=>{},
}

const Context = createContext(initialState)

export function HashContextProvider ({ children }) {
  const [dataHash, setDataHash] = useLocalStorage('avista-documents-hash', {
    dataHash: null
  })

  const value = useMemo(() => ({ dataHash, setDataHash }), [dataHash, setDataHash])

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export default Context
